import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router'
import {ClientLastJob, JobRequestService} from '../job-request.service'
import {inject} from '@angular/core'
import {catchError} from 'rxjs/operators'
import {ErrorMonitor} from '../../../../core/error/error-monitoring.types'
import {Logger} from '../../../../core/logging/logger.types'
import {Observable, of} from 'rxjs'

export const ClientLastJobResolver: (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => Observable<ClientLastJob | undefined> = (route, state) => {
  const logger = inject(Logger)
  const errorMonitor = inject(ErrorMonitor)
  const jobRequestService = inject(JobRequestService)

  return jobRequestService.getClientLastJob().pipe(
    // absorb errors as this is not mission critical but just allows for better UX
    catchError(err => {
      logger.error(err)
      errorMonitor.captureException(err)
      return of(undefined)
    }),
  )
}
